export default "__VITE_ASSET__BPiJSXPa__"